import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaymentService } from '../../../core/auth/payment.service';
import { PaymentMethod } from '@stripe/stripe-js';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { StripeCardComponent } from '../../../shared/stripe-card/stripe-card.component';
import { TitleCasePipe, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, StripeCardComponent, TitleCasePipe, CurrencyPipe, DatePipe]
})
export class BillingComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  ready: boolean;
  paymentInfo: PaymentMethod;
  charges: any[] = [];
  modal: NgbModalRef;

  constructor(
    private readonly paymentService: PaymentService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.subscriptions.add(this.paymentService.getBilling()
      .subscribe(payment => {
        this.ready = true;
        this.paymentInfo = payment.paymentMethod;
        this.charges = payment.charges;
      }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  open(content: any): void {
    this.modal = this.modalService.open(content);
  }

  updateBillingInfo(tokenReadyData: any): void {
    this.subscriptions.add(this.paymentService.updateBillingInfo(tokenReadyData.stripeToken.id)
      .subscribe(paymentInfo => {
        this.paymentInfo = paymentInfo;
        this.modal.close();
      }));
  }
}
